import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=1240bf4e&scoped=true&"
import script from "./ClientDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&id=1240bf4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240bf4e",
  null
  
)

export default component.exports